export enum INCIDENCE_RESOLUTION_PERMISSIONS {
  INCIDENCE_RESOLUTION_VIEW = 'INCIDENCE_RESOLUTIONVIEW',
  INCIDENCE_RESOLUTION_WRITE = 'INCIDENCE_RESOLUTIONWRITE'
}
